module.exports = __webpack_public_path__ + "static/media/signin-webapp-graphic.01d1ff76.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/signin-webapp-graphic.png
// module id = 1118
// module chunks = 0